import React from "react";
import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom";
import Sidebar from "./components/SideBar";
import HomePage from "./components/HomePage";
import CompanyDetails from "./components/CompanyDetails";
import ERPIntegration from "./components/ERPIntegration";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LoginPage from "./components/LoginPage";
import SprintDashboard from "./components/SprintDashboard";
import MastersTab from './components/MasterTabView';
import KanbanBoard from "./components/KanbanBoard";
import Reports from "./components/Reports";
import ClientRequirements from "./components/ClientRequirements";
import ClientOnboarding from "./components/ClientOnboarding";
import { ThemeProvider as MuiThemeProvider, createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import OverallReport from "./components/Reports/OverallReport";
import ClientTATReport from "./components/Reports/ClientTATReport";
import QAFailsReport from "./components/Reports/QAFailsReport";
import BranchAuditReport from "./components/Reports/BranchAuditReport";
import QATimeTrackingReport from "./components/Reports/QATimeTrackingReport";
import ClientRequirementDetail from "./components/ClientRequirementDetail";
import GanttChart from "./components/GanttChart";
import ErrorTrackingDashboard from "./components/ErrorTracking/ErrorTrackingDashboard";
import ErrorList from "./components/ErrorTracking/ErrorList";
import AIFixList from "./components/ErrorTracking/AIFixList";
import ErrorMemberReport from "./components/ErrorTracking/ErrorMemberReport";
import RemindersDashboard from "./components/Reminders/RemindersDashboard";
import RemindersList from "./components/Reminders/RemindersList";
import ReminderForm from "./components/Reminders/ReminderForm";
import ReminderDetailPage from "./components/Reminders/ReminderDetailPage";
import LiveMoveRequests from "./components/LiveMoveRequests";
import TaskAssignments from "./components/TaskAssignments/TaskAssignments";
import MyTasks from "./components/TaskAssignments/MyTasks";
import { ThemeProvider, useTheme } from "./context/ThemeContext";
import "./theme.css";
import CustomerSupportDashboard from "./components/CustomerSupport/CustomerSupportDashboard";
import CustomerSupportTickets from "./components/CustomerSupport/CustomerSupportTickets";
import SLASettings from "./components/CustomerSupport/SLASettings";
import WhatsNewReleases from "./components/WhatsNew/WhatsNewReleases";
import WhatsNewReleaseDetail from "./components/WhatsNew/WhatsNewReleaseDetail";
import { useCustomerSupportAutoSync } from "./components/CustomerSupport/useAutoSync";
import WhatIveDone from "./components/WhatIveDone/WhatIveDone";
import QualityDashboard from "./components/Quality/QualityDashboard";
import ProductionBugs from "./components/Quality/ProductionBugs";
import ProductionBugDetail from "./components/Quality/ProductionBugDetail";
import ProductionReleases from "./components/Quality/ProductionReleases";
import ProductionReleaseDetail from "./components/Quality/ProductionReleaseDetail";
import TestCaseLibrary from "./components/Quality/TestCaseLibrary";

const Layout = () => {
    const location = useLocation();

    // Global background sync: every 30 min while a user is logged in,
    // plus on tab focus. Lives at Layout level so it runs regardless
    // of which route the user is on, and unmounts cleanly on app exit.
    useCustomerSupportAutoSync();

    const hideSidebar = location.pathname === "/";

    return (
        <div style={{ display: "flex" }}>
            {!hideSidebar && <Sidebar />}
            <div style={{ marginLeft: hideSidebar ? "0px" : "188px", flex: 1, minWidth: 0, overflowX: "hidden" }}>
                <Routes>
                    <Route path='/' element={<LoginPage />} />
                    <Route path="/dashboard" element={<HomePage />} />
                    <Route path="/my-work" element={<WhatIveDone />} />
                    <Route path="/Company" element={<CompanyDetails />} />
                    <Route path="/erp-integration" element={<ERPIntegration />} />
                    <Route path="/KanbanBoard" element={<KanbanBoard />} />
                    <Route path="/ClientRequirements" element={<ClientRequirements />} />
                    <Route path="/reports" element={<Reports />} />
                    <Route path="/Onboarding" element={<ClientOnboarding />} />
                    <Route path="/Sprints" element={<SprintDashboard />} />
                    <Route path="/MastersTab" element={<MastersTab />} />
                    <Route path="/gantt" element={<GanttChart />} />
                    <Route path="/Reports/OverallReports" element={<OverallReport />} />
                    <Route path="/Reports/ClientTATReport" element={<ClientTATReport />} />
                    <Route path="/Reports/QAFailsReport" element={<QAFailsReport />} />
                    <Route path="/Reports/SprintPerformance" element={<OverallReport />} />
                    <Route path="/Reports/QAPerformance" element={<OverallReport />} />
                    <Route path="/Reports/BranchAudit" element={<BranchAuditReport />} />
                    <Route path="/Reports/QATimeTracking" element={<QATimeTrackingReport />} />
                    <Route path="/ClientRequirements/:id" element={<ClientRequirementDetail />} />
                    <Route path="/error-tracking" element={<ErrorTrackingDashboard />} />
                    <Route path="/error-tracking/errors" element={<ErrorList />} />
                    <Route path="/error-tracking/ai-fixes" element={<AIFixList />} />
                    <Route path="/error-tracking/member-report" element={<ErrorMemberReport />} />
                    <Route path="/reminders" element={<RemindersDashboard />} />
                    <Route path="/reminders/list" element={<RemindersList />} />
                    <Route path="/reminders/new" element={<ReminderForm />} />
                    <Route path="/reminders/edit/:id" element={<ReminderForm />} />
                    <Route path="/reminders/:id" element={<ReminderDetailPage />} />

                    {/* customer support */}
                    <Route path="/customer-support" element={<CustomerSupportDashboard />} />
                    <Route path="/customer-support/tickets" element={<CustomerSupportTickets />} />
                    <Route path="/customer-support/sla" element={<SLASettings />} />
                    <Route path="/whats-new" element={<WhatsNewReleases />} />
                    <Route path="/whats-new/:id" element={<WhatsNewReleaseDetail />} />

                    <Route path="/live-move" element={<LiveMoveRequests />} />

                    {/* quality: production bugs, releases, regression, test cases */}
                    <Route path="/quality" element={<QualityDashboard />} />
                    <Route path="/quality/bugs" element={<ProductionBugs />} />
                    <Route path="/quality/bugs/:id" element={<ProductionBugDetail />} />
                    <Route path="/quality/releases" element={<ProductionReleases />} />
                    <Route path="/quality/releases/:id" element={<ProductionReleaseDetail />} />
                    <Route path="/quality/test-cases" element={<TestCaseLibrary />} />

                    {/* task assignment */}
                    <Route path="/task-assignments" element={<TaskAssignments />} />
                    <Route path="/my-tasks" element={<MyTasks />} />
                </Routes>
            </div>
        </div>
    );
};

const AppContent = () => {
    const { mode } = useTheme();

    const theme = React.useMemo(() => createTheme({
        palette: {
            mode: mode,
            background: {
                default: mode === "dark" ? "#000" : "#f5f5f9",
                paper: mode === "dark" ? "#121212" : "#ffffff",
            },
            text: {
                primary: mode === "dark" ? "#fff" : "#1a1a2e",
                secondary: mode === "dark" ? "#bbb" : "#666677",
            },
        },
        components: {
            MuiOutlinedInput: {
                styleOverrides: {
                    root: {
                        backgroundColor: mode === "dark" ? "#121212" : "#ffffff",
                        color: mode === "dark" ? "#fff" : "#1a1a2e",
                        "& fieldset": { borderColor: mode === "dark" ? "#555" : "#d0d0d8" },
                        "&:hover fieldset": { borderColor: mode === "dark" ? "#888" : "#aaaabb" },
                        "&.Mui-focused fieldset": { borderColor: mode === "dark" ? "#fff" : "#7c5cfc" },
                    },
                },
            },
            MuiInputLabel: {
                styleOverrides: {
                    root: {
                        color: mode === "dark" ? "#bbb" : "#666677",
                    },
                },
            },
            MuiSvgIcon: {
                styleOverrides: {
                    root: {
                        color: mode === "dark" ? "#fff" : "#666677",
                    },
                },
            },
            MuiChip: {
                styleOverrides: {
                    root: {
                        backgroundColor: mode === "dark" ? "#1e1e1e" : "#f0f0f4",
                        color: mode === "dark" ? "#fff" : "#333344",
                    },
                    deleteIcon: {
                        color: mode === "dark" ? "#fff" : "#666677",
                        "&:hover": {
                            color: mode === "dark" ? "#ccc" : "#333344",
                        },
                    },
                },
            },
            MuiButton: {
                styleOverrides: {
                    root: {
                        textTransform: "none",
                    },
                },
            },
        },
    }), [mode]);

    return (
        <MuiThemeProvider theme={theme}>
            <CssBaseline />
            <Router>
                <Layout />
                <ToastContainer
                    position="bottom-right"
                    autoClose={3000}
                    hideProgressBar={false}
                    newestOnTop={true}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme={mode === "dark" ? "colored" : "light"}
                />
            </Router>
        </MuiThemeProvider>
    );
};

const App = () => {
    return (
        <ThemeProvider>
            <AppContent />
        </ThemeProvider>
    );
};

export default App;
